














































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LineChart from '@/components/Shared/LineChart.vue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatPercent, formatNumber, formatChangePercent } from '@/lib/reportFormatters';
import { ReportMetric } from '@/models/Reports/ManagementReportModels';

@Component({ name: 'RevenueReports', components: { LineChart } })
export default class RevenueReports extends GiganautVue {

  get companyLabel(): string { return this.Labels.company || 'Company'; }


  dimensionHeaders = [
    { text: 'Name', value: 'label' },
    { text: 'Revenue', value: 'revenue', align: 'end' },
    { text: 'GP', value: 'gp', align: 'end' },
    { text: 'Margin %', value: 'margin', align: 'end' },
    { text: 'Hours', value: 'hours', align: 'end' },
    { text: 'Shifts', value: 'shifts', align: 'end' },
  ];

  chargeRateHeaders = [
    { text: 'Name', value: 'label' },
    { text: 'Charge Rate', value: 'chargeRate', align: 'end' },
    { text: 'Pay Rate', value: 'payRate', align: 'end' },
    { text: 'Spread', value: 'spread', align: 'end' },
    { text: 'Hours', value: 'hours', align: 'end' },
  ];

  get revenueOverview() { return ManagementReportsModule.revenueOverview; }
  get revenueByCompany() { return ManagementReportsModule.revenueByCompany; }
  get revenueByPosition() { return ManagementReportsModule.revenueByPosition; }
  get revenueByConsultant() { return ManagementReportsModule.revenueByConsultant; }
  get chargeRateAnalysis() { return ManagementReportsModule.chargeRateAnalysis; }

  get overviewMetrics() {
    const s = this.revenueOverview;
    if (!s) return [];
    return [
      this.buildMetric(s.revenue, 'currency'),
      this.buildMetric(s.grossProfit, 'currency'),
      this.buildMetric(s.marginPercent, 'percent'),
      this.buildMetric(s.shiftsFilled, 'number'),
      this.buildMetric(s.totalHours, 'number'),
    ];
  }

  get revenueTrendChartData() {
    const trend = this.revenueOverview ? this.revenueOverview.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [
        {
          label: 'Revenue',
          borderColor: '#3f51b5',
          backgroundColor: 'rgba(63,81,181,0.1)',
          data: trend.map(t => t.revenue),
          fill: true,
        },
        {
          label: 'GP',
          borderColor: '#ff5c00',
          backgroundColor: 'rgba(255,92,0,0.1)',
          data: trend.map(t => t.gp),
          fill: true,
        },
      ],
    };
  }

  get trendChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            callback: (value: any) => formatCurrency(value),
          },
        }],
      },
      tooltips: {
        callbacks: {
          label: (item: any, data: any) => {
            const label = data.datasets[item.datasetIndex].label || '';
            return label + ': ' + formatCurrency(item.yLabel);
          },
        },
      },
    };
  }

  buildMetric(m: ReportMetric, type: string) {
    let formatted = '';
    if (type === 'currency') formatted = formatCurrency(m.value);
    else if (type === 'percent') formatted = formatPercent(m.value);
    else formatted = formatNumber(m.value);
    return { label: m.label, formatted, changePercent: m.changePercent };
  }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
  fmtChange(v: number) { return formatChangePercent(v); }
}
